/* Inert until a verified same-origin collector URL is configured. */
(function () {
  'use strict';
  var meta = document.querySelector('[data-cb-enquiry-product]');
  if (!meta) return;
  var endpoint = meta.getAttribute('data-cb-enquiry-endpoint') || '/apps/seller-ads/market-terminal/enquiry-click';
  if (!endpoint || !/^\/(?!\/)/.test(endpoint)) return;
  var id = meta.getAttribute('data-cb-enquiry-product');
  if (!/^\d{1,20}$/.test(id || '')) return;
  document.addEventListener('click', function (event) {
    var target = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
    var a = target && target.closest && target.closest('a[href]');
    if (!a || !document.querySelector('main')?.contains(a)) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return; }
    var channel = url.protocol === 'tel:' ? 'call' :
      (url.protocol === 'https:' && /^(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)$/i.test(url.hostname)) ? 'whatsapp' : null;
    if (!channel) return;
    var body = JSON.stringify({channel: channel, product_id: id,
      variant_id: meta.getAttribute('data-cb-enquiry-variant') || '',
      sku: meta.getAttribute('data-cb-enquiry-sku') || '',
      product_title: meta.getAttribute('data-cb-enquiry-title') || '',
      product_path: location.pathname});
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], {type:'text/plain'}))) return;
      fetch(endpoint, {method:'POST', body:body, headers:{'Content-Type':'text/plain'},
        keepalive:true, credentials:'omit', mode:'same-origin'}).catch(function(){});
    } catch (e) { /* Contact link must remain usable. */ }
  }, true);
})();
